// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2iA_a","legacyBtn":"MutateMid_legacyBtn__23w09"};